import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface ButtonProps {
	disabled?: boolean;
}

const PopupBodyWrapper = styled('div')`
	padding: 15px;
`;

const Button = styled('button')`
	box-sizing: border-box;
	width: 100%;
	height: 44px;
	padding: 0 15px;
	border-radius: 8px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 17px;
	line-height: 44px;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};
	color: ${hexToRgba(NewStyleColor.White, 75)};
	cursor: pointer;

	${({ disabled }: ButtonProps) => disabled && `
		pointer-events: none;
		opacity: 0.5;
	`}

	&:hover {
		background-color: ${hexToRgba(NewStyleColor.White, 25)};
	}

	&:active {
		background-color: ${hexToRgba(NewStyleColor.White, 30)};
	}

	&:not(:last-of-type) {
		margin-bottom: 12px;
	}
`;

const Message = styled('div')`
	display: flex;
	margin-top: 10px;
	font-style: italic;
	color: ${hexToRgba(NewStyleColor.White, 75)};

	svg {
		width: 20px;
		height: 20px;
		margin-right: 5px;
		fill: currentColor;
	}
`;

export {
	PopupBodyWrapper,
	Button,
	Message,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/CombinePanel/styles.ts